module.exports = __webpack_public_path__ + "static/media/SH 24.c4b8d603.mp3";